import DOMPurify from "dompurify";
import React, { useMemo } from "react";

const DEFAULT_CONFIG = {
  USE_PROFILES: { html: true },
  ADD_ATTR: ["target", "rel"],
};

export function SafeHtml({ html, as: Tag = "div", config, ...rest }) {
  const clean = useMemo(
    () => DOMPurify.sanitize(html || "", { ...DEFAULT_CONFIG, ...(config || {}) }),
    [html, config]
  );
  return <Tag {...rest} dangerouslySetInnerHTML={{ __html: clean }} />;
}

export default SafeHtml;
